<script>
import ResourceService from '@/services/resources/chemicals_service';
import AdminView from './AdminView.vue';

export default {
  extends: AdminView,
  components: {
    ActionBar: () => import('@/components/action_bars/ChemicalsActionBar.vue'),
  },
  data() {
    return {
      resourceService: ResourceService,
      icon: 'mdi-bottle-tonic',
      urlFragment: 'chemicals',
      resourceParams: {
        include: 'chemical-manufacturer',
        fields: {
          chemicals: 'name,chemical-manufacturer',
          'chemical-manufacturers': 'name',
        },
      },
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Manufacturer', value: 'chemicalManufacturer.name' },
      ],
      sortBy: ['name'],
    };
  },
};
</script>
